import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { computeUpdatedFilters } from "helpers/filters"
import { DEFAULT_FILTER_SCOPE, computeBaseChangeNormalization } from "helpers/filter-scope"
import { NORMALIZATION, removeUnsupportedFilters, removeUnsupportedAddedFilters } from "helpers/segments"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { isGroupedByMembership } from "helpers/rollups"
import { ANALYZE_SECTION, createAnalyzeGroupingAndFilterReducer } from "helpers/analyze"

export const { Types, Creators } = createActions("ompnt/modules/asset-analytics", {
  setGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "asset-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  setNormalization: {
    props: ["normalization"],
    track: true,
    trackType: "asset-normalization-selection",
    trackPayload: ({ normalization }) => ({ normalization }),
  },
  setFilterScope: ["filterScope"],
  toggleFilters: [],
  toggleShowNotHeld: {
    props: ["value"],
    track: true,
    trackType: "asset-toggle-not-held",
    trackPayload: ({ value }) => value,
  },
  updateFilters: {
    props: ["filter"],
    track: true,
    trackType: "asset-segment-filters-updated",
    trackPayload: ({ filter }) => ({ filter }),
  },
})

const INITIAL_STATE = {
  filter: null,
  filtersVisible: false,
  grouping: null,
  normalization: NORMALIZATION.CONTRIBUTION,
  filterScope: DEFAULT_FILTER_SCOPE,
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetGrouping(state, { grouping }) {
  return { ...state, grouping }
}

function handleSetNormalization(state, { normalization }) {
  return { ...state, normalization }
}

function handleSetFilterScope(state, { filterScope }) {
  return { ...state, filterScope }
}

function handleToggleFilters(state) {
  return { ...state, filtersVisible: !state.filtersVisible }
}

function handleToggleShowNotHeld(state, { value }) {
  return { ...state, showNotHeld: value, page: 0 }
}

function handleSetSelectedBase(state, { selectedBase }) {
  let newGrouping = state.grouping
  const isActive = !!selectedBase
  const normalization = computeBaseChangeNormalization(state, isActive)
  const newFilter = removeUnsupportedFilters(state.filter, isActive, normalization)
  const newAddedFilters = removeUnsupportedAddedFilters(state.addedFilters, isActive, normalization)
  if (selectedBase) {
    if (isGroupedByMembership(newGrouping)) {
      newGrouping = null
    }
  }
  return { ...state, grouping: newGrouping, filter: newFilter, addedFilters: newAddedFilters }
}

export const HANDLERS = {
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [Types.SET_GROUPING]: handleSetGrouping,
  [Types.SET_NORMALIZATION]: handleSetNormalization,
  [Types.SET_FILTER_SCOPE]: handleSetFilterScope,
  [Types.TOGGLE_FILTERS]: handleToggleFilters,
  [Types.TOGGLE_SHOW_NOT_HELD]: handleToggleShowNotHeld,
  [BaseTypes.SET_SELECTED_BASE]: handleSetSelectedBase,
  ...createAnalyzeGroupingAndFilterReducer(ANALYZE_SECTION.ASSETS),
}

export default createReducer(INITIAL_STATE, HANDLERS)
